export default __webpack_public_path__ + "static/media/SFTSchriftedSansTRIAL-Medium-BF6413e2024d36d.eabaeef6.ttf";